import { COBStep } from './ClientOnboarding.constants';
const pageByStep = {
    [COBStep.welcome]: {
        pageName: 'client_onboarding_step_welcome',
        pageTitle: 'clientOnboardingStepWelcome'
    },
    [COBStep.selectAPackage]: {
        pageName: 'client_onboarding_step_select_package',
        pageTitle: 'clientOnboardingStepSelectAPackage'
    },
    [COBStep.reviewServices]: {
        pageName: 'client_onboarding_step_review_services',
        pageTitle: 'clientOnboardingStepReviewServices'
    },
    [COBStep.approveTerms]: {
        pageName: 'client_onboarding_step_approve_terms',
        pageTitle: 'clientOnboardingStepApproveTerms'
    },
    [COBStep.paymentMethod]: {
        pageName: 'client_onboarding_step_payment_method',
        pageTitle: 'clientOnboardingStepPaymentMethod'
    },
    [COBStep.address]: {
        pageName: 'client_onboarding_step_address',
        pageTitle: 'clientOnboardingStepAddress'
    },
    [COBStep.allSet]: {
        pageName: 'client_onboarding_step_all_set',
        pageTitle: 'clientOnboardingStepAllSet'
    },
    [COBStep.introduction]: {
        pageName: 'client_onboarding_step_introduction',
        pageTitle: 'clientOnboardingStepIntroduction'
    },
    [COBStep.signAndApprove]: {
        pageName: 'client_onboarding_step_sign_and_approve',
        pageTitle: 'clientOnboardingStepSignAndApprove'
    },
    [COBStep.termsOfService1]: {
        pageName: 'client_onboarding_step_terms_of_service_1',
        pageTitle: 'clientOnboardingStepTermsOfService1'
    },
    [COBStep.termsOfService2]: {
        pageName: 'client_onboarding_step_terms_of_service_2',
        pageTitle: 'clientOnboardingStepTermsOfService2'
    },
    [COBStep.termsOfService3]: {
        pageName: 'client_onboarding_step_terms_of_service_3',
        pageTitle: 'clientOnboardingStepTermsOfService3'
    },
    [COBStep.termsOfService4]: {
        pageName: 'client_onboarding_step_terms_of_service_4',
        pageTitle: 'clientOnboardingStepTermsOfService4'
    },
    [COBStep.customPage1]: {
        pageName: 'client_onboarding_step_custom_page_1',
        pageTitle: 'clientOnboardingStepCustomPage1'
    },
    [COBStep.customPage2]: {
        pageName: 'client_onboarding_step_custom_page_2',
        pageTitle: 'clientOnboardingStepCustomPage2'
    },
    [COBStep.customPage3]: {
        pageName: 'client_onboarding_step_custom_page_3',
        pageTitle: 'clientOnboardingStepCustomPage3'
    },
    [COBStep.customPage4]: {
        pageName: 'client_onboarding_step_custom_page_4',
        pageTitle: 'clientOnboardingStepCustomPage4'
    },
    [COBStep.customPage5]: {
        pageName: 'client_onboarding_step_custom_page_5',
        pageTitle: 'clientOnboardingStepCustomPage5'
    },
    [COBStep.customPage6]: {
        pageName: 'client_onboarding_step_custom_page_6',
        pageTitle: 'clientOnboardingStepCustomPage6'
    },
    [COBStep.customPage7]: {
        pageName: 'client_onboarding_step_custom_page_7',
        pageTitle: 'clientOnboardingStepCustomPage7'
    },
    [COBStep.customPage8]: {
        pageName: 'client_onboarding_step_custom_page_8',
        pageTitle: 'clientOnboardingStepCustomPage8'
    },
    [COBStep.customPage9]: {
        pageName: 'client_onboarding_step_custom_page_9',
        pageTitle: 'clientOnboardingStepCustomPage9'
    },
    [COBStep.customPage10]: {
        pageName: 'client_onboarding_step_custom_page_10',
        pageTitle: 'clientOnboardingStepCustomPage10'
    }
};
const isCOBStep = (value)=>Object.prototype.hasOwnProperty.call(pageByStep, value);
export const clientOnboardingStepPageOf = (step)=>step != null && isCOBStep(step) ? pageByStep[step] : undefined;
